export function getURLParameter(param) {
  let query = window.location.search.substring(1);
  let pairs = query.split('&');

  for (let i = 0; i < pairs.length; i++) {
    let pair = pairs[i].split('=');
    if (pair[0] === param) {
      if (pair[1].length > 0)
        return pair[1];
    }
  }

  return false;
}